var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"custom-toggle"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}}),_c('span',{staticClass:"custom-toggle-slider rounded-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }